import React from 'react';
import { ListGroup } from 'react-bootstrap';

const SummaryRow = ({ label, value, highlight = false, muted = false }) => (
  <ListGroup.Item className="d-flex justify-content-between align-items-center border-0 px-0 py-1 bg-transparent">
    <span className={muted ? 'text-muted' : ''}>{label}</span>
    <span className={highlight ? 'fw-bold fs-5 text-success' : 'fw-semibold'}>{value}</span>
  </ListGroup.Item>
);

const PurchaseSummary = ({ quote, formatMoney, volumeTier, advanceOption }) => (
  <ListGroup variant="flush">
    <SummaryRow label="Pacote / quantidade" value={`${quote.quantity} chaves`} />
    <SummaryRow label="Preço unitário base" value={formatMoney(quote.unitPrice)} muted />
    <SummaryRow label="Subtotal" value={formatMoney(quote.subtotal)} />
    {quote.volumeDiscountPercent > 0 && (
      <SummaryRow
        label={`Desconto volume (${volumeTier?.label || ''} −${quote.volumeDiscountPercent}%)`}
        value={`− ${formatMoney(quote.volumeDiscountAmount)}`}
        muted
      />
    )}
    {quote.advanceDiscountPercent > 0 && (
      <SummaryRow
        label={`Antecipação (${advanceOption?.label || ''} −${quote.advanceDiscountPercent}%)`}
        value={`− ${formatMoney(quote.advanceDiscountAmount)}`}
        muted
      />
    )}
    <SummaryRow
      label="Total da compra"
      value={formatMoney(quote.total)}
      highlight
    />
    <SummaryRow
      label="Valor médio por chave"
      value={formatMoney(quote.effectiveUnitPrice)}
      muted
    />
    {quote.advanceMonths > 1 && (
      <SummaryRow
        label="Crédito antecipado"
        value={`${quote.advanceMonths} meses`}
        muted
      />
    )}
  </ListGroup>
);

export default PurchaseSummary;
